import { FlaskConical } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { CatalogPage } from "@/components/common/CatalogPage";
import { labTestsApi } from "@/lib/api";
import type { LabTest } from "@/lib/api/types";
import { fmtCurrency } from "@/lib/utils";

/** Laboratory tests shown in the app (English + Swahili). */
export default function LabTestsPage() {
  return (
    <CatalogPage<LabTest>
      queryKey="lab-tests"
      title="Lab tests"
      subtitle={(n) => `${n} laboratory tests with preparation notes and typical prices.`}
      icon={FlaskConical}
      noun="lab test"
      searchPlaceholder="Search lab tests…"
      source={{ kind: "paged", fetch: labTestsApi.list }}
      itemLabel={(t) => t.name}
      columns={[
        { header: "Name", render: (t) => <span className="font-semibold">{t.name}</span> },
        { header: "Code", render: (t) => t.testCode ?? "—" },
        { header: "Sample", render: (t) => t.sampleType ?? "—" },
        { header: "Fasting", render: (t) => (t.fastingRequired ? <Badge variant="warning">Fasting</Badge> : <Badge variant="muted">No</Badge>) },
        { header: "Avg. price", render: (t) => (t.averagePrice != null ? fmtCurrency(t.averagePrice, "TZS") : "—") },
      ]}
      fields={[
        { key: "name", label: "Name (English)", required: true, half: true, placeholder: "Full blood count" },
        { key: "nameSwahili", label: "Name (Swahili)", required: true, half: true, placeholder: "Kipimo cha damu kamili" },
        { key: "testCode", label: "Test code", half: true, placeholder: "FBC" },
        { key: "category", label: "Category", half: true, placeholder: "Haematology" },
        { key: "sampleType", label: "Sample type", half: true, placeholder: "Blood" },
        { key: "turnaroundTime", label: "Turnaround time", half: true, placeholder: "24 hours" },
        { key: "normalRange", label: "Normal range", half: true },
        { key: "unitOfMeasure", label: "Unit", half: true },
        { key: "averagePrice", label: "Average price (TZS)", type: "number" },
        { key: "description", label: "Description (English)", type: "textarea" },
        { key: "descriptionSwahili", label: "Description (Swahili)", type: "textarea" },
        { key: "preparationInstructions", label: "Preparation instructions", type: "textarea" },
        { key: "fastingRequired", label: "Fasting required", type: "checkbox" },
      ]}
      create={labTestsApi.create}
      update={labTestsApi.update}
      remove={labTestsApi.remove}
    />
  );
}
